import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axios } from 'lib/axios';
import { qnaKey } from './queryKeys';

const markRead = (resource, id, section) =>
  axios.put(`/api/${resource}/${id}/qna/read`, { section });

export const useMarkRead = (resource, id) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (section) => markRead(resource, id, section),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: qnaKey(resource, id, 'summary') }),
  });
};
